/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/DashboardPageBlockLightReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./DashboardPageBlockLightReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DashboardPageLightReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.DashboardPageBlockLightReport);
  }
}(this, function(ApiClient, DashboardPageBlockLightReport) {
  'use strict';




  /**
   * The DashboardPageLightReport model module.
   * @module model/DashboardPageLightReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DashboardPageLightReport</code>.
   * @alias module:model/DashboardPageLightReport
   * @class
   */
  var exports = function() {
    var _this = this;






  };

  /**
   * Constructs a <code>DashboardPageLightReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DashboardPageLightReport} obj Optional instance to populate.
   * @return {module:model/DashboardPageLightReport} The populated <code>DashboardPageLightReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('GroupID')) {
        obj['GroupID'] = ApiClient.convertToType(data['GroupID'], 'Integer');
      }
      if (data.hasOwnProperty('IsPrivate')) {
        obj['IsPrivate'] = ApiClient.convertToType(data['IsPrivate'], 'Boolean');
      }
      if (data.hasOwnProperty('Blocks')) {
        obj['Blocks'] = ApiClient.convertToType(data['Blocks'], [DashboardPageBlockLightReport]);
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} GroupID
   */
  exports.prototype['GroupID'] = undefined;
  /**
   * @member {Boolean} IsPrivate
   * @default false
   */
  exports.prototype['IsPrivate'] = false;
  /**
   * @member {Array.<module:model/DashboardPageBlockLightReport>} Blocks
   */
  exports.prototype['Blocks'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


